import { render, staticRenderFns } from "./FabEditor.vue?vue&type=template&id=658799ee&scoped=true"
import script from "./FabEditor.vue?vue&type=script&lang=js"
export * from "./FabEditor.vue?vue&type=script&lang=js"
import style0 from "./FabEditor.vue?vue&type=style&index=0&id=658799ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658799ee",
  null
  
)

export default component.exports